module.exports = __webpack_public_path__ + "static/media/27.fc207106.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/27.jpg
// module id = 202
// module chunks = 0